import { Building2 } from 'lucide-react';

interface TableBranchEmptyProps {
  title?: string;
  description?: string;
}

const TableBranchEmpty = ({
  title = 'Seleccione una sucursal',
  description = 'Para gestionar las mesas del restaurante, primero debe seleccionar una sucursal.',
}: TableBranchEmptyProps) => {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center px-5 text-center">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-2xl border border-primary/20 bg-primary/10 text-primary">
        <Building2 className="h-10 w-10" />
      </div>

      <h3 className="text-lg font-semibold text-black dark:text-white">
        {title}
      </h3>

      <p className="mt-2 max-w-md text-sm text-bodydark2">
        {description}
      </p>
    </div>
  );
};

export default TableBranchEmpty;